enum EGoal {
  PAYMENT = 'PAYMENT',
  CREATE_MERCHANT = 'CREATE_MERCHANT',
  REGISTER = 'REGISTER',
}
export default EGoal;
